import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import state from './state'
import mutations from './mutations'
import createLogger from 'vuex/dist/logger'
import app from './modules/app'
import tagsView from './modules/tagsView'
import * as httpAgent from 'utils/http'
import down from './modules/down'
import user from './modules/user'
import goodsManagement from './modules/goodsManagement'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

// actions
const actions = {
    /**
     * 权限按钮
     *
     * @export
     * @returns
     */
    addButtonAll({
        commit
    }, payload) {
        if (payload.menuKey) {
            let params = payload.menuKey.replace(/-/g, ":")
            httpAgent.GET('/wmsadmin/admin/buttonAll', {
                menuKey: params
            }).subscribe(data => {
                commit('addButtonAll', data.data)
            }, error => {})
        }
    },
    saveHeaderForm({
        commit,
        state
    }, {
        saveData,
        type
    }) {
        commit('SAVE_HEADER_FORM', saveData)
    }

}

export default new Vuex.Store({
    modules: {
        app,
        tagsView,
        down,
        user,
        goodsManagement
    },
    actions,
    getters,
    state,
    mutations,
    strict: debug,
    plugins: debug ? [createLogger()] : []
})